<template>
  <div>
    <BlocoFiltroPesquisa
      nome-do-form="LevantamentoMarketingForm"
      :ordenar-por="['data']"
      :ordenar-nomes="['Data']"
      :dados="linhas"
      :botao-download="true"
      :botao-adicionar="false"
      @pesquisar="pesquisar"
      @ordenar="ordenar"
      @download="download"
    >
      <template #form>
        <div class="row">
          <div class="col-xs-8 col-sm-4 col-md-2 col-lg-2">
            <SelecionarData
              id="dataInicio"
              :valor="filtro.dataInicio"
              :validacao="v$.filtro.dataInicio"
              label="Data Início"
              @atualizar="filtro.dataInicio = $event"
            />
          </div>
          <div class="col-xs-8 col-sm-4 col-md-2 col-lg-2">
            <SelecionarData
              id="dataFim"
              :valor="filtro.dataFim"
              :validacao="v$.filtro.dataFim"
              label="Data Fim"
              @atualizar="filtro.dataFim = $event"
            />
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <br />
    <LevantamentoMarketingTabela v-if="linhas.length" :linhas="linhas" />
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import moment from 'moment'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import SelecionarData from '@/componentes/formulario/SelecionarData'
import { useMenu } from '@/composables/useMenu'
import MensagemServico from '@/servicos/MensagemServico'
import RelatorioServico from '@/servicos/RelatorioServico'

import LevantamentoMarketingTabela from './LevantamentoMarketingTabela'
const mensagemServico = new MensagemServico()

export default {
  components: {
    LevantamentoMarketingTabela,
    BlocoFiltroPesquisa,
    SelecionarData,
  },

  setup() {
    useMenu(57)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      solicitantes: [],
      linhas: [],
      servico: new RelatorioServico(),
      nomeResultado: 'linhas',
      filtro: {
        dataInicio: moment().startOf('month'),
        dataFim: moment().endOf('month'),
        ordenarPor: 'data',
        gestante: 'TODAS',
        ortopedia: 'NÃO',
      },
      opcoesGestante: [
        { _id: 'TODAS', descricao: 'Todas' },
        { _id: 'SIM', descricao: 'Sim' },
        { _id: 'NÃO', descricao: 'Não' },
      ],
      opcoesOrtopedia: [
        { _id: 'SIM', descricao: 'Sim' },
        { _id: 'NÃO', descricao: 'Não' },
      ],
    }
  },
  computed: {
    dataInicio() {
      return moment().subtract(1, 'M').format('DD/MM/YYYY')
    },
    dataFim() {
      return moment().format('DD/MM/YYYY')
    },
  },
  validations: {
    filtro: {
      dataInicio: { required },
      dataFim: { required },
    },
  },
  methods: {
    pesquisar() {
      this.v$.$touch()

      if (this.v$.filtro.$invalid) {
        mensagemServico.alerta('Informe a Data Início e Data Fim.')
      } else {
        this.servico.relatorioLevantamentoMarketing(this.filtro).then((res) => {
          this.linhas = res.relatorio
        })
      }
    },
    download() {
      this.v$.$touch()

      if (this.v$.filtro.$invalid) {
        mensagemServico.alerta('Informe a Data Início e Data Fim.')
      } else if (this.linhas.length == 0) {
        mensagemServico.alerta(
          'Não há dados para exportar. Ajuste os filtros e efetue a pesquisa novamente'
        )
      } else {
        this.servico
          .relatorioLevantamentoMarketingDownload(this.filtro)
          .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'report.xlsx')
            document.body.appendChild(link)
            link.click()
          })
      }
    },
    ordenar(prop) {
      this.filtro.ordenarPor = prop
      this.pesquisar()
    },
    atualizarGestante(valor) {
      this.filtro.gestante = valor
    },
    atualizarOrtopedia(valor) {
      this.filtro.ortopedia = valor
    },
  },
}
</script>
